import { TrackJS } from 'trackjs';

import { WallpaperApiMethods } from '../helpers/wallpaper-api-methods';

// Creative is needed to validate the origin of the messages
let creative = null;
// DOM node is needed to send messages to the iframe
let wallpaperNode = null;

// Because of browser's security restrictions, we need to know
// the remote host of wallpapers, and specify this value
// when the message is sent.
function remoteUrl(creative) {
  const url = new URL(creative.src);
  return url.origin;
}

// Parse the message sent by the wallpaper, and execute the command
function parseMessage({ data }) {
  let payload = {};

  try {
    // Try to parse the JSON message.
    payload = data.raw ? data : JSON.parse(data);
  } catch {
    throw new Error(`UnableToParseMessage: ${data}`);
  }

  // Check if command exists.
  if (!payload.command) {
    throw new Error(`EmptyWallpaperCommand: ${data}`);
  }

  // Check if the method exists.
  const method = `api_${payload.command}`;
  if (!WallpaperApiMethods[method]) {
    throw new Error(`MethodNotFound: ${method}`);
  }

  return {
    method,
    data: payload.data,
  };
}

function receiveWallpaperApiMethod(event) {
  // We must only accept messages from trusted origins
  if (remoteUrl(creative) !== event.origin) return false;

  try {
    const { method, data } = parseMessage(event);
    const state = WallpaperApiMethods[method](...data);
    if (method === 'api_getState') {
      send(state, 'update');
    }
  } catch (error) {
    TrackJS.track(error);
  }
}

function createPayload(command, ...data) {
  return JSON.stringify({
    command,
    data,
  });
}

function send(state, command = 'start') {
  wallpaperNode.contentWindow.postMessage(
    createPayload(command, state),
    remoteUrl(creative)
  );
}

export const PostMessageService = {
  // Initialize the postMessage listener and the start event signal to
  // wallpapers with the current state of the application
  init(node, media) {
    creative = media;
    wallpaperNode = node;

    // Listen to messages sent from wallpapers
    window.addEventListener('message', receiveWallpaperApiMethod);

    const state = WallpaperApiMethods.getCurrentState(creative);
    send(state);
  },

  stop() {
    wallpaperNode = null;
    creative = null;

    window.removeEventListener('message', receiveWallpaperApiMethod);
  },
};
